/**
 * Colour classes for each risk band. Kept out of the "use client" calculator
 * so the server-rendered page can read them too: a server component cannot
 * index into a client module's exports.
 */

import type { BandId } from "@/lib/marketing/risk-matrix/matrix";

export const BAND_CLASSES: Record<BandId, string> = {
  low: "bg-done-bg text-done",
  medium: "bg-accent-light text-brand-700",
  high: "bg-danger-bg text-danger",
};
